import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import { useState, useEffect, useRef } from 'react';
import Not from './notifications';
import toast from 'react-hot-toast';
import { ChevronLeft, CreditCard, Bell, LogOut, User as UserIcon } from 'lucide-react';

const TopBar = ({ activePage, lastPage, homePage }) => {
  const { user } = useAuth();
  const data = useData();
  const navigate = useNavigate();
  const [isDialogVisible, setDialogVisible] = useState(false);
  const [not, setNot] = useState(false);
  const dialogRef = useRef(null);
  const notRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isDialogVisible && dialogRef.current && !dialogRef.current.contains(e.target)) {
        setDialogVisible(false);
      }
      if (not && notRef.current && !notRef.current.contains(e.target)) {
        setNot(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isDialogVisible, not]);

  const toggleDialog = () => {
    setDialogVisible(!isDialogVisible);
  };

  const toggleNot = () => {
    setNot(!not);
  };

  async function Logout() {
    setDialogVisible(false);
    if (user?.email == 'test@vfs.co.mz') {
      toast.success('Logout com sucesso!');
      localStorage.removeItem('token');
      navigate('/test');
      return;
    }
    toast.loading('A sair...');
    try {
      await data.makeRequest({
        method: 'post',
        url: 'api/logout',
        data: { refreshToken: localStorage.getItem('refresh-token') },
        withToken: true,
        error: ``,
      }, 0);
      toast.remove();
      toast.success('Logout com sucesso!');
      data.setUpdateTable(Math.random());
      localStorage.removeItem('token');
      navigate('/login');
    } catch (e) {
      toast.remove();
      let msg = 'Acorreu um erro, tente novamente';
      if (e.response) {
        msg = 'Erro, inesperado. Contacte seu administrador';
      } else if (e.code == 'ERR_NETWORK') {
        msg = 'Verfique sua internet e tente novamente';
      }
      toast.error(msg);
    }
    setDialogVisible(true);
  }

  return (
    <div className="flex h-14 items-center justify-between gap-2 bg-white rounded-2xl px-3 shadow-sm ring-1 ring-slate-200/50 sm:h-16 sm:gap-4 sm:px-4 md:px-6">
      {/* ── Left side ─────────────────────────────────────────── */}
      <div className="flex min-w-0 flex-1 items-center gap-2 sm:gap-3">
        <button
          onClick={() => navigate(-1)}
          className="hidden h-7 w-7 shrink-0 items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100 md:flex"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>

        <div className="flex min-w-0 items-center gap-2 sm:gap-3">
          {homePage && user?.role != 'admin' && (
            <div
              onClick={() => navigate('/credit-simulator')}
              className="inline-flex shrink-0 cursor-pointer items-center gap-1.5 rounded-lg border border-blue-400 bg-blue-400 px-2 py-1 text-xs font-medium text-white transition hover:opacity-80 sm:px-2.5"
            >
              <CreditCard className="h-3.5 w-3.5" />
              <span className="hidden sm:inline">Simulador de crédito</span>
            </div>
          )}

          <span className="truncate text-sm font-medium text-slate-700">
            {activePage}
          </span>
        </div>
      </div>

      {/* ── Right side ────────────────────────────────────────── */}
      <div className="flex shrink-0 items-center gap-1 sm:gap-2">
        {/* Notification button hidden */}
        {/* 
        <div className="relative" ref={notRef}>
          <button
            onClick={toggleNot}
            className="flex h-8 w-8 items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100"
          >
            <Bell className="h-4 w-4" />
          </button>
          {not && (
            <div className="absolute bottom-[-10px] right-0 z-20">
              <Not />
            </div>
          )}
        </div>
        */}

        {/* User menu */}
        <div className="relative" ref={dialogRef}>
          <div
            onClick={toggleDialog}
            className="flex cursor-pointer items-center gap-2 rounded-lg px-1.5 py-1.5 transition hover:bg-slate-100 sm:px-2"
          >
            <div className="hidden flex-col text-right sm:flex">
              <span className="max-w-[140px] truncate text-sm font-medium text-slate-800">
                {user?.name}
              </span>
              <span className="max-w-[140px] truncate text-xs text-slate-500">
                {user?.email}
              </span>
            </div>
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-100">
              <UserIcon className="h-5 w-5 text-slate-600" />
            </div>
          </div>

          {isDialogVisible && (
            <div
              onClick={Logout}
              className="absolute right-0 top-full z-20 mt-2 flex w-36 cursor-pointer flex-col items-center gap-2 rounded-lg bg-white px-4 py-3 shadow-lg ring-1 ring-slate-200"
            >
              <span className="text-sm text-slate-700">Sair</span>
            </div>
          )}
        </div>

        {/* Mobile menu toggle */}
        {data.menuOpen === false && (
          <button
            onClick={() => data.setMenuOpen(true)}
            className="flex h-8 w-8 shrink-0 flex-col items-center justify-center gap-1 rounded-lg text-slate-500 hover:bg-slate-100 md:hidden"
          >
            <span className="block h-0.5 w-5 rounded bg-slate-600"></span>
            <span className="block h-0.5 w-5 rounded bg-slate-600"></span>
            <span className="block h-0.5 w-5 rounded bg-slate-600"></span>
          </button>
        )}
      </div>
    </div>
  );
};

export default TopBar;